import React from 'react';
import background from '../../assets/icemin.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoArcticicemin extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="LAND"
        description="Arctic Ice Minimum"
        paragraph="Arctic sea ice, measured each September, is now declining at a rate of 12.85 percent per decade, relative to the 1981 to 2010 average. (NASA)"
        background={background}
     />
  
  );
 }
}   

export default InfoArcticicemin;